import type { IconSvgObject } from './types';

const Sword01Icon: IconSvgObject = [
  ["path", { d: "M2.5 19.5C2.98686 19.5717 3.45571 19.7949 3.83041 20.1696C4.20512 20.5443 4.42832 21.0131 4.5 21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 16L4 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 16.5L20.5 7.5L21.5 2.5L16.5 3.5L7.5 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 13L4.57179 13.0001C5.10209 13.0002 5.61066 13.2109 5.98565 13.5859L10.4142 18.0142C10.7893 18.3893 11 18.898 11 19.4285V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Sword01Icon;
